const SortIcon=()=>
    {
        return (
<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 4.66667H8V3.33333H0M0 0V1.33333H12V0M0 8H4V6.66667H0V8Z" fill="#A3A3A3"/>
</svg>
        )
    }

    export default SortIcon